import { render, staticRenderFns } from "./myEmail.vue?vue&type=template&id=48722e94&scoped=true&"
import script from "./myEmail.vue?vue&type=script&lang=js&"
export * from "./myEmail.vue?vue&type=script&lang=js&"
import style0 from "./myEmail.vue?vue&type=style&index=0&id=48722e94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48722e94",
  null
  
)

export default component.exports